import axios from "../http";

let module = "/student";

function getStudentList(data) {
    return axios.post(module, data);
}

function updateStudent(data) {
    return axios.post(module+"/"+data.id, data);
}

function querySameClassmate(data) {
    return axios.get(module+"/classmates/"+data.id);
}

function getStudentDetail(data) {
    return axios.get(module+"/"+data.id);
}

function getAttentionStudent() {
    return axios.get(module+"/attention");
}

function changeClasses(data){
    return axios.put(module+"/changeClasses",data);
}

function hideStudent(data){
    return axios.post(module+"/hideStudent", data);
}

function unHideStudent(data){
    return axios.put(module+"/unhide/"+data.id);
}

function outer(data){
    return axios.post(module+"/outer",data);
}

function add2Outsourcing(data){
    return axios.post(module+"/outsourcing", data);
}

function addStudent(data){
    return axios.put(module, data);
}

export default {
    getStudentList,
    updateStudent,
    querySameClassmate,
    getStudentDetail,
    getAttentionStudent,
    changeClasses,
    hideStudent,
    unHideStudent,
    outer,
    add2Outsourcing,
    addStudent,
}
